import { UIController } from './ui/UIController.js';
import './types/index.js';

// Initialize the game when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new UIController();

  // Display version info
  const versionElement = document.getElementById('version');
  if (versionElement) {
    // Format build timestamp
    const buildDate = new Date(__BUILD_TIMESTAMP__);
    const formattedDate = buildDate.toLocaleString('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).replace(/\//g, '-');

    versionElement.textContent = `v${__COMMIT_HASH__}`;
    versionElement.title = `Build: ${__COMMIT_HASH__}\nDate: ${formattedDate}`;
  }

  console.log('Klondike Solitaire initialized');
  console.log(`Version: ${__COMMIT_HASH__}`);
  console.log(`Build: ${__BUILD_TIMESTAMP__}`);
  console.log('Controls:');
  console.log('- Drag cards to move them');
  console.log('- Click stock to draw cards');
  console.log('- Ctrl+Z to undo, Ctrl+Y to redo');
  console.log('- N to start a new game');
});
